/**
 * 复购可选开药门诊abTest
 */
const env = { appEnv: 'qa' as const };

/**
 * 复购场景中患者可选开药门诊试验Id
 */
export const rePurchaseExpIds = {
  dev: '582256426513076285',
  qa: '582256426513076285',
  prod: '582261822355144745',
};

/**
 * ab appId
 */
export const AbAppIds = {
  dev: '582253779819171903',
  qa: '582253779819171903',
  prod: '577869490457436221',
};

/** 对照组 */
export enum RePurchaseGroup {
  /** 空白对照组 60% */
  contrastEmpty = '0',
  /** 对照组A 20% */
  contrastA = '1',
  /** 对照组B 20% */
  contrastB = '2',
}

// abTest应用Id
export const AbAppId = AbAppIds[env.appEnv];

// abTest试验Id
export const rePurchaseExpId = rePurchaseExpIds[env.appEnv];
